// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IDayOfWeekScheduleSchema {
  /**  Звонить с  **/
  callFrom?: string;
  /**  Звонить до  **/
  callTo?: string;
  /**  День недели  **/
  day: EDay;
  /**  Является ли день рабочим  **/
  isWorkingDay: boolean;
}
export enum EDay {
  /** Пятница **/
  'Friday' = 'Friday',
  /** Понедельник **/
  'Monday' = 'Monday',
  /** Суббота **/
  'Saturday' = 'Saturday',
  /** Воскресенье **/
  'Sunday' = 'Sunday',
  /** Четверг **/
  'Thursday' = 'Thursday',
  /** Вторник **/
  'Tuesday' = 'Tuesday',
  /** Среда **/
  'Wednesday' = 'Wednesday',
}
